export const beautyLevelThree = [
  
      { name: "Face Makeup", categoryId: "beauty_face_makeup", parentCategoryId: "beauty_makeup", level: 3 },
      { name: "Eye Makeup", categoryId: "beauty_eye_makeup", parentCategoryId: "beauty_makeup", level: 3 },
      { name: "Lip Makeup", categoryId: "beauty_lip_makeup", parentCategoryId: "beauty_makeup", level: 3 },
      { name: "Makeup Tools", categoryId: "beauty_makeup_tools", parentCategoryId: "beauty_makeup", level: 3 },
    
      { name: "Moisturizers", categoryId: "beauty_moisturizers", parentCategoryId: "beauty_skincare", level: 3 },
      { name: "Cleansers", categoryId: "beauty_cleansers", parentCategoryId: "beauty_skincare", level: 3 },
      { name: "Face Masks", categoryId: "beauty_face_masks", parentCategoryId: "beauty_skincare", level: 3 },
      { name: "Sunscreen", categoryId: "beauty_sunscreen", parentCategoryId: "beauty_skincare", level: 3 },
  
      { name: "Shampoos", categoryId: "beauty_shampoos", parentCategoryId: "beauty_hair_care", level: 3 },
      { name: "Conditioners", categoryId: "beauty_conditioners", parentCategoryId: "beauty_hair_care", level: 3 },
      { name: "Hair Oils", categoryId: "beauty_hair_oils", parentCategoryId: "beauty_hair_care", level: 3 },
      { name: "Hair Treatments", categoryId: "beauty_hair_treatments", parentCategoryId: "beauty_hair_care", level: 3 },
    
      { name: "Perfumes", categoryId: "beauty_perfumes", parentCategoryId: "beauty_fragrance", level: 3 },
      { name: "Deodorants", categoryId: "beauty_deodorants", parentCategoryId: "beauty_fragrance", level: 3 },
      { name: "Body Mists", categoryId: "beauty_body_mists", parentCategoryId: "beauty_fragrance", level: 3 },
      { name: "Roll-Ons", categoryId: "beauty_roll_ons", parentCategoryId: "beauty_fragrance", level: 3 },
    
      { name: "Body Wash", categoryId: "beauty_body_wash", parentCategoryId: "beauty_personal_care", level: 3 },
      { name: "Hand Creams", categoryId: "beauty_hand_creams", parentCategoryId: "beauty_personal_care", level: 3 },
      { name: "Foot Care", categoryId: "beauty_foot_care", parentCategoryId: "beauty_personal_care", level: 3 },
      { name: "Hygiene Products", categoryId: "beauty_hygiene_products", parentCategoryId: "beauty_personal_care", level: 3 },
    ]

  